import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import clsx from "clsx";
import { Icon } from "../icon/Icon";
import {
  dropdownContent,
  dropdownItem,
  dropdownTrigger,
  triggerChevron
} from "./DropdownMenu.css";

export function DropdownMenu({
  ...props
}: React.ComponentProps<typeof DropdownMenuPrimitive.Root>) {
  return <DropdownMenuPrimitive.Root data-slot="dropdown-menu" {...props} />;
}

export function DropdownMenuTrigger({
  children,
  className,
  ...props
}: React.ComponentProps<typeof DropdownMenuPrimitive.Trigger>) {
  return (
    <DropdownMenuPrimitive.Trigger
      className={clsx(dropdownTrigger, className)}
      data-slot="dropdown-menu-trigger"
      {...props}
    >
      {children}
      <div className={triggerChevron}>
        <Icon name="chevron-down" />
      </div>
    </DropdownMenuPrimitive.Trigger>
  );
}

export function DropdownMenuContent({
  ...props
}: React.ComponentProps<typeof DropdownMenuPrimitive.Content>) {
  return (
    <DropdownMenuPrimitive.Content
      data-slot="dropdown-menu-content"
      style={{
        position: "relative"
      }}
      className={dropdownContent}
      {...props}
    />
  );
}

export function DropdownMenuItem({
  className,
  ...props
}: React.ComponentProps<typeof DropdownMenuPrimitive.Item> & {}) {
  return (
    <DropdownMenuPrimitive.Item
      data-slot="dropdown-menu-item"
      className={clsx(dropdownItem, className)}
      {...props}
    />
  );
}
